import { createFileRoute } from '@tanstack/react-router';
import { EditorPage } from '../../../features/studio/pages/editor.tsx';

export const Route = createFileRoute('/_app/studio/bundles/$bundleId/versions/$version/')({
  component: EditorRoute,
});

function EditorRoute() {
  const { bundleId, version } = Route.useParams();
  return <EditorPage bundleId={bundleId} version={version} />;
}
